import { TextField, InputAdornment, Grid } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { Typography, IconButton, Box, Stack } from "@financeable-com-au/financeable-ui";
import { AddOnsProps, AssetAddOnsProps } from "@/utils/interface";

const AssetAddOns = ({ assetAddOns, handle, isDisableEdit }: AssetAddOnsProps) => {
  const totalPrice = assetAddOns?.reduce((sum: number, row: AddOnsProps) => sum + (row.price || 0), 0);

  return (
    <Box sx={{ width: "100%" }}>
      {assetAddOns?.length > 0 ? (
        <>
          <Grid container direction="row" spacing={1} xs={12} sm={12} md={12}>
            <Grid item xs={9} sm={9} md={9}>
              <Typography fontWeight="bold">Description</Typography>
            </Grid>
            <Grid item xs={2.5} sm={2.5} md={2.5}>
              <Typography fontWeight="bold">Price</Typography>
            </Grid>
            <Grid item xs={0.5} sm={0.5} md={0.5}>
              <Typography fontWeight="bold"></Typography>
            </Grid>
          </Grid>

          {assetAddOns?.map((row: AddOnsProps, index: number) => (
            <Stack sx={{ width: "100%", mt: 1, py: 1 }}>
              <Grid container direction="row" spacing={1} xs={12} sm={12} md={12}>
                <Grid item xs={9} sm={9} md={9}>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    placeholder="Add Description..."
                    value={row.description}
                    disabled={isDisableEdit}
                    onChange={(e) => handle.onChangeAddOns(index, "description", e.target.value)}
                    onBlur={() => handle.updateAsset({ addOns: assetAddOns })}
                  />
                </Grid>
                <Grid item xs={2.5} sm={2.5} md={2.5}>
                  <TextField
                    size="small"
                    variant="outlined"
                    value={row.price}
                    type="number"
                    disabled={isDisableEdit}
                    onChange={(e) => handle.onChangeAddOns(index, "price", e.target.value)}
                    onBlur={() => handle.updateAsset({ addOns: assetAddOns })}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">$</InputAdornment>,
                    }}
                  />
                </Grid>
                <Grid item xs={0.5} sm={0.5} md={0.5}>
                  <Stack alignItems="center" justifyContent="center">
                    <IconButton
                      aria-label="delete"
                      disabled={isDisableEdit}
                      onClick={() => handle.onRemoveAddOns(index)}
                      style={{ backgroundColor: "transparent", marginTop: "5px" }}
                    >
                      <DeleteIcon color="error" />
                    </IconButton>
                  </Stack>
                </Grid>
              </Grid>
            </Stack>
          ))}

          {/* Calculate total price */}
          <Box py={1} mt={3} borderRadius={6}>
            <Grid container direction="row" spacing={1} xs={12} sm={12} md={12}>
              <Grid item xs={9} sm={9} md={9}>
                <Typography fontWeight="bold" level="body-md" textAlign="end">
                  Total Add-ons :
                </Typography>
              </Grid>
              <Grid item xs={2.5} sm={2.5} md={2.5}>
                <Typography fontWeight="bold" level="body-md" textAlign="end">
                  ${totalPrice.toLocaleString()}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </>
      ) : (
        <Stack justifyContent="center" alignItems="center">
          <Typography level="body-md">No add-ons found. Click “Add” to create one.</Typography>
        </Stack>
      )}
    </Box>
  );
};

export default AssetAddOns;
